
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register/[id]",
      function () {
        return require("private-next-pages/register/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/register/[id]"])
      });
    }
  